module.exports = __webpack_public_path__ + "static/media/icon_extension_obj.6eb6473e.svg";